import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Grid2X2, Users, Info } from 'lucide-react';
import { trackEvent } from '../lib/customerEventTracker';

const ITEMS = [
  { to: '/', label: 'Home', icon: Home, cta: 'bottom_nav_home' },
  { to: '/all-services', label: 'All Services', icon: Grid2X2, cta: 'bottom_nav_all_services' },
  { to: '/referral', label: 'Referral', icon: Users, cta: 'bottom_nav_referral' },
  { to: '/about', label: 'About', icon: Info, cta: 'bottom_nav_about' },
];

const MobileBottomNav = () => {
  const { pathname } = useLocation();
  const isActiveItem = (to) => {
    if (to === '/') return pathname === '/';
    if (to === '/all-services') {
      return pathname === '/all-services'
        || pathname.startsWith('/services/')
        || pathname.startsWith('/get-started')
        || pathname.startsWith('/file-itr');
    }
    return pathname === to || pathname.startsWith(`${to}/`);
  };

  return (
    <nav className="lg:hidden fixed inset-x-0 bottom-0 z-40 border-t border-gray-200 bg-white/95 backdrop-blur-sm shadow-[0_-6px_20px_rgba(15,37,64,0.08)]">
      <div className="mx-auto grid max-w-[680px] grid-cols-4">
        {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          onClick={() =>
            trackEvent({
              event_name: 'cta_click',
              event_action: 'click',
              event_status: 'success',
              event_category: 'navigation',
              cta_name: item.cta,
            })
          }
          className={() =>
            `flex flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-semibold transition-colors ${
              isActiveItem(item.to) ? 'text-[#14A098]' : 'text-[#0f2540]'
            }`
          }
        >
          <item.icon className="h-[18px] w-[18px]" aria-hidden />
          <span className="leading-none">{item.label}</span>
        </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
